/* import __COLOCATED_TEMPLATE__ from './sla-archive-modal.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();